// @flow

import React from 'react';
import ClickthroughOrCloseupLink from 'app/common/react/components/PinRep/components/ClickthroughOrCloseupLink';
import smartTruncate from 'app/common/lib/util/smartTruncate';
import Text from 'app/common/react/components/common/ExperimentalLegoGestalt/Text';
import { type Pin } from 'app/common/react/components/PinRep/types';

export type NumberOfLines = 1 | 2 | 3;

type Props = {|
  pin: Pin,

  // pinTitle is determined in PinRepConfiguration as it depends on the surface
  pinTitle: string,
  numberOfLines?: NumberOfLines,
  singleLineMaxLength: number,
|};

export default function Title({ numberOfLines = 2, pin, singleLineMaxLength, pinTitle }: Props) {
  const maxLength = numberOfLines * singleLineMaxLength;
  const truncatedTitle = smartTruncate(pinTitle, maxLength);

  return (
    <ClickthroughOrCloseupLink pin={pin}>
      <Text
        color="darkGray"
        data-test-id="PinRep-Title"
        overflow="normal"
        size="sm"
        weight="semibold"
      >
        {truncatedTitle}
      </Text>
    </ClickthroughOrCloseupLink>
  );
}
